/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    object, string, func, shape, arrayOf,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import CustomsMessageView from './CustomsMessageView';
import CustomsCardWrapper from '../CustomsCardWrapper/CustomsCardWrapper';

const styles = () => ({
    selectCustomsContainer: {
        margin: '30px 0px',
        display: 'flex',
        justifyContent: 'center',
    },
});
const PersonalizeMessageCustoms = ({
    customsCard, classes, message, setMessage, csLabelData, toolbarProps,
}) => (
    <Grid item sm={12} className={classes.selectCustomsContainer}>
        <CustomsCardWrapper customsCard={customsCard}>
            <CustomsMessageView
                messageData={message}
                setCardMessage={setMessage}
                csLabelData={csLabelData}
                toolbarProps={toolbarProps}
            />
        </CustomsCardWrapper>
    </Grid>
);
PersonalizeMessageCustoms.propTypes = {
    classes: object.isRequired,
    customsCard: string.isRequired,
    message: string.isRequired,
    setMessage: func.isRequired,
    csLabelData: shape({
        message_settings: shape({
            heading_font_size: string,
        }),
    }).isRequired,
    toolbarProps: arrayOf(shape({
        value: string,
        label: string,
        icon: string,
        title: string,
        type: string,
        list: arrayOf(shape({
            label: string,
            value: string,
        })),
    })),
};
PersonalizeMessageCustoms.defaultProps = {
    toolbarProps: {},
};
export default withStyles(styles)(PersonalizeMessageCustoms);
